<template lang="pug">
  span
    RowItemTemplate
      template(slot="label")
        span 課税価格の合計額
      template(slot="value")
        span {{イ}}万円
    .death(v-if="deathKouzyo != '0'") ※生命保険の非課税金額{{deathKouzyo}}万円を差し引いた金額
    RowItemTemplate
      template(slot="label")
        span 基礎控除額
      template(slot="value")
        span {{ハ}}万円
    RowItemTemplate
      template(slot="label")
        span 課税遺産総額
      template(slot="value")
        span {{ニ}}万円
    RowItemTemplate
      template(slot="label")
        span 相続税の総額
      template(slot="value")
        span {{taxPrice}}万円
</template>

<script lang="js">
import RowItemTemplate from '@/components/step03/RowItemTemplate.vue';

export default {
  components: {
    RowItemTemplate,
  },

  props: {
    イ: {
      type: String,
      default: '',
    },
    ハ: {
      type: String,
      default: '',
    },
    ニ: {
      type: String,
      default: '',
    },
    deathKouzyo: {
      type: String,
      default: '',
    },
    taxPrice: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
.death
  color: #979797
  font-size: 14px
  margin-top: -10px
@media screen and (max-width: $break-header)
  .death
    font-size: 11px
</style>